<template>
    <div>
        <div class="image" :style="'background-image: url(' + $store.user.distrikt.image + ')'" style="
        background-size: cover !important;
        background-position: 50% 20% !important;
      ">
            <div class="card_header">
                <h1>
                    <!-- <div class="icon" v-if="$store.user.distrikt.icon">
            <img :src="$store.user.distrikt.icon" />
          </div> -->
                    {{ $store.user.distrikt.name }}
                </h1>
                <p>
                    {{ $store.user.distrikt.text }} {{ $store.user.distrikt.guidelines }}
                </p>
                <p class="font-bold pt-4">
                    Select 5 cards from the deck below
                </p>
            </div>
        </div>
        <masonry :cols="3" :gutter="10" class="table" v-if="filterDistrikt().length > 2">
            <Card v-for="(item, index) in filterDistrikt()" :item="item" :key="index" :selectable="true" />
        </masonry>
        <div class="nav_bar">
            <h3 class="button next" v-if="$store.user.cards.length == 5" @click="nextStep()">
                Next
            </h3>
            <h3 class="button" v-if="$store.user.cards.length <= 4">
                {{ 5 - $store.user.cards.length }} Cards remaining ({{2-regen}} Regenerative Cards, {{3-single_use}} One Time Play Cards)
            </h3>
        </div>
    </div>
</template>
<script>
import Card from "./Card.vue";
export default {
    name: "HelloWorld",
    data: () => ({}),
    components: {
        Card,
    },
    computed: {
        userCards() {
          if (this.$store.user && this.$store.user.cards) {
           return this.$store.cards.filter((el) => {
                return this.$store.user.cards.includes(el.id);
            });
          } else {
            return false
          }
        },
        regen() {
            if (this.userCards) {
                var cards = this.userCards.filter(x => !x.single_use);
                return cards.length;
            } else {
              return 0
            }
        },
        single_use() {
            if (this.userCards) {
                var cards = this.userCards.filter(x => x.single_use);
                return cards.length;
            } else {
              return 0
            }
        },
    },
    methods: {
        getDistrikt() {
            return this.$store.distrikts.filter(
                (x) => x.slug == this.$store.distrikt
            )[0];
        },
        select(id) {
            if (!this.isSelected(id)) {
                this.$store.user.cards.push(id);
            } else {
                const index = this.$store.user.cards.indexOf(id);
                if (index > -1) {
                    this.$store.user.cards.splice(index, 1);
                }
            }
        },
        filterDistrikt() {
            if (this.$store.cards.length > 1) {
                return this.$store.cards.filter(
                    (item) =>
                    item.distrikt.toLowerCase() ==
                    this.$store.user.distrikt.slug.toLowerCase()
                );
            }
        },
        isSelected(id) {
            if (this.$store.user.cards.includes(id)) {
                return true;
            } else {
                return false;
            }
        },
    },
    async created() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body {
    background: #fafafa;
}

.header {
    text-align: center;
    width: 80%;
    max-width: 1220px;
    margin: 40px auto 0;

    h1 {
        font-weight: 100;
        margin-bottom: 30px;
        font-family: "Times New Roman", Times, serif;
    }
}

.table {
    width: 85%;
    max-width: 1080px;
    margin: 60px auto !important;

    .card {
        @apply mb-2;
    }
}

.image {
    height: auto;
    width: 100%;
    display: flex;
    position: relative;
    @apply items-center justify-start;

    .card_header {
        width: 50%;
        height: 100%;
        margin: inherit;
        backdrop-filter: blur(20px);
        color: white;
        @apply py-14 px-20 text-left flex flex-col justify-center;
        background: linear-gradient(180deg,
            rgba(0, 0, 0, 1) 0%,
            rgba(0, 0, 0, 0) 130%);

        h1 {
            color: white;
            @apply text-left border-b pb-3 mb-4 justify-start pl-0;

            .icon {
                background: rgba(255, 255, 255, 0.8);
                width: 50px;
                margin-top: 3px;
                height: 50px;
                display: flex;
                margin-right: 14px;
                align-items: center;
                justify-content: center;
                padding: 10px;
                border-radius: 100px;

                img {
                    height: 30px;
                    margin-top: 6px;
                }
            }
        }

        p {
            color: white;
        }
    }

    .wrapper {
        width: 50%;
        background: rgba(255, 255, 255, 0.1);
        padding: 24px;
        backdrop-filter: blur(10px);
        max-width: 1220px;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    h1 {
        display: flex;
        align-items: center;
        font-family: "Times New Roman", Times, serif;
        font-weight: 100;
        font-size: 3rem;
        padding: 0;
        width: 100%;
        padding-bottom: 0rem;
        margin: 0 auto 0rem;
        text-transform: capitalize;
    }

    p {
        width: 100%;
        margin: 0;
        color: black;
        font-weight: light;
        font-size: 1.2rem;
    }

    .wrapper {
        position: relative;
        z-index: 9;
    }
}

.nav_bar {
    @apply flex items-center justify-center;
    position: fixed;
    bottom: 0;
    height: 90px;
    width: 100%;
    border-top: 1px solid #ddd;
    box-shadow: 0 -10px 10px rgba(0, 0, 0, 0.04);
    background: #fff;

    h3.button {
        background: black;
        color: white;
        text-decoration: none;
        @apply rounded-full p-3 px-6 font-bold;

        &.next {
            background: green;
        }
    }
}

.nav_top {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    z-index: 99;
    height: 60px;
    width: 100%;
    box-shadow: 0 -10px 10px rgba(0, 0, 0, 0.04);
    background: rgba(0, 0, 0, 0.034);
}
</style>